import { API } from '../../modules/api';
import { UTILS } from '../../modules/utils';
import { USER_DATA_MANAGER } from '../../modules/data'
export default {
	/**
	 * 通过我的用户列表
	 * */
	getMyUserListData({state}, params) {
		API.getMyUserList({}, function(data) {
			console.log('获取我的用户数据列表成功:::::::', data)
			state.myUserList = USER_DATA_MANAGER.getMyUserListDataByData(data);
			if(params && params.cb && typeof(params.cb) == 'function') {
				params.cb(data);
			}
		});
	},
	/**
	 * 添加先知主人到我的用户列表
	 */
	addMyUserListData({state}, data) {
		var newData = USER_DATA_MANAGER.getMyUserDataByData(data);
		var newIndex = UTILS.getIdIndexInObjectArray(state.myUserList, data.id);
		if(newIndex == -1) {
			state.myUserList.push(newData);
		}
		console.log('添加我的用户数据成功:::::::', state.myUserList);
	},
	/**
	 * 更新我的用户列表
	 */
	updateMyUserListData({state}, params) {
		var curIndex = UTILS.getIdIndexInObjectArray(state.myUserList, params.id);
		console.log('updateMyUserListData------', params)
		if(curIndex != -1) {
			state.myUserList[curIndex].f_name = params.name;
			state.myUserList[curIndex].firstL = UTILS.getFirstLetter(params.name);
		}
	}
}